var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { DottedLine, IconTextValue, useChat, useLang } from '@shapeable/ui';
import { GptOutputButton } from './gpt-output-button';
import { classNames } from '@shapeable/utils';
import { InfoIcon } from '@shapeable/icons';
var cls = classNames('gpt-output-controls');
export var GptOutputControlsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    align-self: stretch;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    align-self: stretch;\n  "])))
});
var DottedLineStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  "])))
});
var DisclaimerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    padding-right: ", ";\n    font-weight: 400;\n    font-style: italic;\n  "], ["\n    font-size: ", ";\n    padding-right: ", ";\n    font-weight: 400;\n    font-style: italic;\n  "])), theme.FONT_SIZE(12), theme.UNIT(2))
});
var OutputButtonsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  "])))
});
var ClipboardButtonStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  DottedLine: styled(DottedLine)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), DottedLineStyles),
  Body: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Disclaimer: styled(IconTextValue)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), DisclaimerStyles),
  OutputButtons: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), OutputButtonsStyles),
  ClipboardButton: styled(GptOutputButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ClipboardButtonStyles),
  CollapseButton: styled(GptOutputButton)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ClipboardButtonStyles)
};
export var GptOutputControls = function (props) {
  var className = props.className,
    onCollapseClick = props.onCollapseClick,
    text = props.text;
  var t = useLang();
  var title = useChat().title;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.DottedLine, {
    gap: 5
  }), React.createElement(My.Body, null, React.createElement(My.Disclaimer, {
    colors: {
      text: 'text'
    },
    iconComponent: InfoIcon
  }, t("This content was generated by ".concat(title))), React.createElement(My.OutputButtons, null, React.createElement(My.ClipboardButton, {
    variant: 'copy',
    gptText: text
  }, t('Copy to Clipboard')), React.createElement(My.DottedLine, {
    width: 3,
    gap: 5
  }), React.createElement(My.CollapseButton, {
    onClick: onCollapseClick,
    variant: 'collapse'
  }, t('Collapse')))));
};
GptOutputControls.cls = cls;
GptOutputControls.defaultProps = GptOutputControlsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;